<template>
	<div :class="[companyClass, canScroll]" v-if="userPermissionsFilter.admin">
		<div class="page-exchangerates flex column mb-20">
			<div class="page-header">
				<h1 class="pageTitle">SMS Provider Details</h1>
			</div>

			<div class="mt-0 w-100">
				<div style="float: right;">
					<el-button type="primary" icon="el-icon-plus" @click="addProvider">Add New</el-button>
				</div>
			</div>


			<div class="mt-10">
				<resize-observer @notify="handleResize" />
				<div class="table-responsive">
					<table class="table" id="datatable" style="color:white;">
						<thead>
							<tr>
								<th>Name</th>
								<th>Active</th>
								<th>Company Name</th>
								<th>Description</th>
								<th>Action</th>
								<th>Status</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in smsProvidersData" :key="item.id">
								<td>{{ item.name }}</td>
								<td><span v-if="item.isServiceInUse">Active</span> <span v-else>Dormant</span></td>
								<td>{{ item.companyName }}</td>
								<td>{{ item.serviceAddress }}</td>
								<td><el-button type="primary" icon="el-icon-edit"
										@click="editProvider(item)">EDIT</el-button></td>
								<td>
									<el-button v-show="item.isServiceInUse" type="success">
										<i class="mdi mdi-alert-octagon" style="color:red"></i> Active</el-button>
									<el-button v-show="!item.isServiceInUse" type="primary"
										@click="setActiveProvider(item.id)"><i class="mdi mdi-check-circle"></i> Set
										Active</el-button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>


				<el-dialog :show-close="true" :custom-class="'user-dialog'" :visible="dialogFormVisible"
					@close="closeDialog" :before-close="handleClose">
					<div class="form-box">
						<div class="row">
							<div class="row mt-12">
								<div class="col col-md-12">
									<strong>Provider Name</strong>
									<el-input placeholder="SMS Provider Name" v-model="this.smsproviders.name" name="name"
										v-validate="'required'" data-vv-as="name"></el-input>
									<transition name="fade">
										<span class="danger-text">{{ errors.first('name') }}</span>
									</transition>
								</div>
							</div>
							<div class="row mt-12">
								<div class="col col-md-12">
									<strong>Consumer URL</strong>
									<el-input placeholder="Provider Consumer URL" v-model="this.smsproviders.serviceURL"
										name="serviceURL" v-validate="'required'" data-vv-as="serviceURL"></el-input>
									<transition name="fade">
										<span class="danger-text">{{ errors.first('serviceURL') }}</span>
									</transition>
								</div>
							</div>
							<div class="row mt-12">
								<div class="col col-md-12">
									<strong>Consumer Key</strong>
									<el-input placeholder="Provider Consumer Key" v-model="this.smsproviders.serviceKey"
										name="serviceKey" v-validate="'required'" data-vv-as="serviceKey"></el-input>
									<transition name="fade">
										<span class="danger-text">{{ errors.first('serviceKey') }}</span>
									</transition>
								</div>
							</div>
							<div class="row mt-12">
								<div class="col col-md-12">
									<strong>Consumer Secret</strong>
									<el-input placeholder="Provider Consumer Secret"
										v-model="this.smsproviders.serviceSecret" name="serviceSecret"
										v-validate="'required'" data-vv-as="serviceSecret"></el-input>
									<transition name="fade">
										<span class="danger-text">{{ errors.first('serviceSecret') }}</span>
									</transition>
								</div>
							</div>
							<div class="row mt-12">
								<div class="col col-md-12">
									<el-button type="success" class="btn-group" style="width:30%" @click="editSMSProvider">
										<i class="mdi mdi-account-check"></i><span> Edit Provider</span>
									</el-button>
								</div>
							</div>
						</div>
					</div>
				</el-dialog>


				<el-dialog :show-close="true" :custom-class="'user-dialog'" :visible="dialogForm2Visible"
					@close="closeDialog" :before-close="handleClose">
					<div class="form-box">
						<div class="row">
							<div class="row mt-12">
								<div class="col col-md-12">
									<strong>Provider Name</strong>
									<el-input placeholder="SMS Provider Name" v-model="this.smsproviders.name" name="name"
										v-validate="'required'" data-vv-as="name"></el-input>
									<transition name="fade">
										<span class="danger-text">{{ errors.first('name') }}</span>
									</transition>
								</div>
							</div>
							<div class="row mt-12">
								<div class="col col-md-12">
									<strong>Provider Short Name</strong>
									<el-input placeholder="SMS Provider Short Name"
										v-model="this.smsproviders.serviceNiceName" name="serviceNiceName"
										v-validate="'required'" data-vv-as="serviceNiceName"></el-input>
									<transition name="fade">
										<span class="danger-text">{{ errors.first('serviceNiceName') }}</span>
									</transition>
								</div>
							</div>
							<div class="row mt-12">
								<div class="col col-md-12">
									<strong>Consumer URL</strong>
									<el-input placeholder="Provider Consumer URL" v-model="this.smsproviders.serviceURL"
										name="serviceURL" v-validate="'required'" data-vv-as="serviceURL"></el-input>
									<transition name="fade">
										<span class="danger-text">{{ errors.first('serviceURL') }}</span>
									</transition>
								</div>
							</div>
							<div class="row mt-12">
								<div class="col col-md-12">
									<strong>Consumer Key</strong>
									<el-input placeholder="Provider Consumer Key" v-model="this.smsproviders.serviceKey"
										name="serviceKey" v-validate="'required'" data-vv-as="serviceKey"></el-input>
									<transition name="fade">
										<span class="danger-text">{{ errors.first('serviceKey') }}</span>
									</transition>
								</div>
							</div>
							<div class="row mt-12">
								<div class="col col-md-12">
									<strong>Consumer Secret</strong>
									<el-input placeholder="Provider Consumer Secret"
										v-model="this.smsproviders.serviceSecret" name="serviceSecret"
										v-validate="'required'" data-vv-as="serviceSecret"></el-input>
									<transition name="fade">
										<span class="danger-text">{{ errors.first('serviceSecret') }}</span>
									</transition>
								</div>
							</div>
							<div class="row mt-12">
								<div class="col col-md-12">
									<strong>Type</strong>
									<el-select v-model="this.smsproviders.serviceAddress" filterable clearable
										placeholder="Select Type" class="mb-10" style="width:100%" name="serviceAddress"
										v-validate="'required'" data-vv-as="serviceAddress">
										<el-option label="Promotional" value="Promotional"></el-option>
										<el-option label="Transactional" value="Transactional"></el-option>
									</el-select>
									<transition name="fade">
										<span class="danger-text">{{ errors.first('serviceAddress') }}</span>
									</transition>
								</div>
							</div>
							<div class="row mt-12">
								<div class="col col-md-12">
									<el-button type="success" class="btn-group" style="width:30%" @click="editSMSProvider">
										<i class="mdi mdi-account-check"></i><span> Create Provider</span>
									</el-button>
								</div>
							</div>
						</div>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import $ from 'jquery';

import moment from 'moment';
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/';

export default {
	name: "SMSProvider",
	data() {
		return {
			smsProvidersData: [],
			smsproviders: {
				id: "",
				name: "",
				isServiceInUse: false,
				companyID: "",
				serviceNiceName: "",
				serviceKey: "",
				serviceSecret: "",
				serviceURL: "",
				serviceAddress: "",
			},
		};
	},
	computed: {
	},
	methods: {
		editProvider(data) {
			if (data) {
				this.dialogFormVisible = true;
				this.smsproviders = data;
				this.smsproviders.id = data.id;
			}
		},

		editSMSProvider() {
			if ((this.smsproviders.name) && (this.smsproviders.companyID)) {
				this.$confirm('Are you sure to edit this provider?').then(_ => {
					this.addSMSProvider(this.smsproviders).then(result => {
						if (result) {
							this.refreshUsers(this.smsproviders.companyID);
							this.dialogFormVisible = false;
							this.successMessage('Successifully.');
						}
						else {
							this.errorMessage('Failed');
						}
					});
				}).catch(_ => { });
			}
		},


		addProvider() {
			this.dialogForm2Visible = true;
		},

		addSMSProvider() {
			if ((this.smsproviders.name) && (this.smsproviders.collectionMode)) {
				this.$confirm('Are you sure to create this provider?').then(_ => {
					//this.processingActive();
					this.addSMSProvider(this.smsproviders).then(result => {
						if (result) {
							this.refreshUsers(this.smsproviders.companyID);
							this.dialogAddFormVisible = false;
							this.successMessage('Successifully.');
						}
						else {
							this.errorMessage('Failed.');
						}
					});
				}).catch(_ => { });
			}
		},


		setActiveProvider(id) {
			if (id > 0) {
				this.setActiveSMSProvider(id).then((result) => {
					if (result === true) {
						this.refreshUsers(this.smsproviders.companyID);
						this.successMessage('Successifully.');
					}
					else {
						this.errorMessage('Failed.');
					}
				});
			}
		},

		refreshUsers(companyID) {
			this.startLoader("Getting User Transactions...");
			this.getSMSProviders(companyID)
				.then((result) => {
					this.smsProvidersData = result;
					this.$nextTick(function () {
						this.initDt()
					});
					this.stopLoader();
				}).catch(err => { this.errorMessage("An Error Occured. " + err); this.stopLoader(); });
		},
		initDt() {
			var tblDT = $('#datatable').DataTable({
				retrieve: true,
				dom: 'Blfrtip',
				"aaSorting": [],
				buttons: [
					//'print'
				],
			});
		}
	},
	created() {
		this.getLoggedInCompany()
			.then((loggedInCompany) => {
				this.smsproviders.companyID = loggedInCompany.id;
				this.refreshUsers(loggedInCompany.id);
			});
		//this.getOperationalCountries();
	},
	mixins: [PermissionsMixins],
};
</script>


<style lang="scss" scoped>
@import "../../assets/scss/_variables";
</style>